class Parameters {
    constructor() {
    }
    //正式使用
    statusList = [
        { id: 1, name: '受理中', display: false, isSelect: false },
        { id: 2, name: '手術中', display: false, isSelect: true }, //暫時不用
        { id: 3, name: '住院中', display: false, isSelect: true },
        { id: 4, name: 'ICU', display: false, isSelect: true },
        { id: 5, name: '長期照養', display: false, isSelect: true },
        { id: 6, name: '野訓中', display: false, isSelect: false },
        { id: 7, name: '待野放', display: false, isSelect: true },
        { id: 91, name: '結案-追蹤中', display: false, isSelect: false }, //結案
        { id: 92, name: '結案-已野放', display: false, isSelect: false }, //結案
        { id: 93, name: '結案-待解剖', display: false, isSelect: false }, //結案
        { id: 94, name: '結案-死亡', display: false, isSelect: true }, //結案
        { id: 95, name: '結案-轉診', display: false, isSelect: true }, //結案
        { id: 96, name: '結案-轉收容', display: false, isSelect: true }, //結案
        { id: 100, name: '關閉病歷', display: false, isSelect: true }, //結案
        { id: 404, name: '結案-錯誤關閉', display: false, isSelect: true }, //結案
    ]

    departments = [
        { value: "D001", name: "秘書長室" },
        { value: "D002", name: "動物醫院" },
        { value: "D003", name: "獸醫課" },
        { value: "D004", name: "照養課" },
        { value: "D005", name: "環境教育課" },
        { value: "D006", name: "公益勸募課" },
        { value: "D007", name: "野外調查課" },
        { value: "D008", name: "屏東分院" },
    ]

    genderList = [
        { id: 1, name: '公' },
        { id: 2, name: '母' },
        { id: 3, name: '待查' },
    ]

    pregnancyStatusList = [
        { id: 1, name: '未懷孕' },
        { id: 2, name: '懷孕中' },
        { id: 3, name: '哺乳中' },
    ]

    getStatusNameById(id) {
        const statusItem = this.statusList.find(item => item.id == id)
        return statusItem ? statusItem.name : 'not find';
    }

    global_unit = [
        { id: 1, ch_name: '個/微升', en_name: 'cells/µL', tips: '個/微升 (cells/µL) - cells per microliter' },
        { id: 2, ch_name: '個/毫升', en_name: 'cells/mL', tips: '個/毫升 (cells/mL) - cells per milliliter' },
        { id: 3, ch_name: '個/升', en_name: 'cells/L', tips: '個/升 (cells/L) - cells per liter' },
        { id: 4, ch_name: '10^9/L', en_name: '10^9/L', tips: '每升十億個 (Billions of cells per liter)' },
        { id: 5, ch_name: '10^12/L', en_name: '10^12/L', tips: '每升一兆個 (Trillions of cells per liter)' },
        { id: 11, ch_name: 'mg/dL', en_name: 'mg/dL', tips: '毫克每分升 (Milligrams per deciliter)' },
        { id: 12, ch_name: 'g/dL', en_name: 'g/dL', tips: '克每分升 (Grams per deciliter)' },
        { id: 13, ch_name: 'µg/dL', en_name: 'µg/dL', tips: '微克每分升 (Micrograms per deciliter)' },
        { id: 14, ch_name: 'µmol/L', en_name: 'µmol/L', tips: '微摩爾每升 (Micromoles per liter)' },
        { id: 15, ch_name: 'mmol/L', en_name: 'mmol/L', tips: '毫摩爾每升 (Millimoles per liter)' },
        { id: 16, ch_name: 'ng/mL', en_name: 'ng/mL', tips: '奈克每毫升 (Nanograms per milliliter)' },
        { id: 17, ch_name: 'pg/mL', en_name: 'pg/mL', tips: '皮克每毫升 (Picograms per milliliter)' },
        { id: 18, ch_name: 'U/L', en_name: 'U/L', tips: '單位每升 (Units per liter)' },
        { id: 19, ch_name: 'U/mL', en_name: 'U/mL', tips: '單位每毫升 (Units per milliliter)' },
        { id: 31, ch_name: '%', en_name: '%', tips: '百分比 (Percentage)' },
        { id: 32, ch_name: '‰', en_name: '‰', tips: '千分比 (Permille)' },
        { id: 33, ch_name: '比值', en_name: 'Ratio', tips: 'Ratio (e.g., A/G ratio, Albumin/Globulin ratio)' },
        { id: 41, ch_name: '克', en_name: 'g', tips: '克(g)' },
        { id: 42, ch_name: '毫克', en_name: 'mg', tips: '毫克(mg)' },
        { id: 43, ch_name: '微克', en_name: 'µg', tips: '微克 (Microgram)' },
        { id: 44, ch_name: '公斤', en_name: 'kg', tips: '公斤(kg)' },
        { id: 51, ch_name: '公升', en_name: 'L', tips: '公升(L)' },
        { id: 52, ch_name: '毫升', en_name: 'mL', tips: '毫升 (Milliliter)' },
        { id: 53, ch_name: '微升', en_name: 'µL', tips: '微升 (Microliter)' },
        { id: 54, ch_name: '飛升', en_name: 'fL', tips: '飛升 (Femtoliter)' },
        { id: 55, ch_name: '杯', en_name: 'Cup', tips: '杯 (Cup) - 常用於量液體或乾糧' },
        { id: 56, ch_name: '匙', en_name: 'Tbsp', tips: '匙 (Tablespoon) - 通常等於15 mL' },
        { id: 57, ch_name: '茶匙', en_name: 'Tsp', tips: '茶匙 (Teaspoon) - 通常等於5 mL' },
        { id: 71, ch_name: '份', en_name: 'Portion', tips: '份 (Portion) - 通常用於描述一餐的食物量' },
        { id: 72, ch_name: '片', en_name: 'Slice', tips: '片 (Slice) - 例如肉片、餅乾片等' },
        { id: 73, ch_name: '塊', en_name: 'block', tips: '塊 (block) - 例如肉塊、食物塊' },
        { id: 74, ch_name: '顆', en_name: 'Piece', tips: '顆 (Piece) - 例如水果、丸狀食物' },
        { id: 91, ch_name: '罐', en_name: 'Can', tips: '罐 (Can) - 常用於罐裝寵物食品' },
        { id: 92, ch_name: '包', en_name: 'Pack', tips: '包 (Pack) - 例如小包裝乾糧' },
        { id: 93, ch_name: '粒', en_name: 'Pellet', tips: '粒 (Pellet) - 例如飼料顆粒' },
        { id: 94, ch_name: '隻', en_name: 'bugs', tips: '隻 (bugs) - 例如有機體單位，昆蟲或者生物' },
        { id: 95, ch_name: '口', en_name: 'mouth', tips: '口 (mouth) - 非客觀單位，已吃了幾口為主' },
        { id: 111, ch_name: '個', en_name: 'Piece', tips: '個 (Piece)' },
        { id: 112, ch_name: '箱', en_name: 'Box', tips: '箱 (Box)' },
        { id: 113, ch_name: '包', en_name: 'Package', tips: '包 (Package)' },
        { id: 114, ch_name: '打', en_name: 'Dozen', tips: '打 (Dozen)' },
        { id: 115, ch_name: '瓶', en_name: 'Bottle', tips: '瓶 (Bottle)' },
        { id: 116, ch_name: '袋', en_name: 'Bag', tips: '袋 (Bag)' },
        { id: 117, ch_name: '捆', en_name: 'Bundle', tips: '捆 (Bundle)' },
        { id: 118, ch_name: '卷', en_name: 'Roll', tips: '卷 (Roll)' },
        { id: 119, ch_name: '件', en_name: 'Item', tips: '件 (Item)' },
        { id: 120, ch_name: '公升', en_name: 'Liter', tips: '公升 (Liter) - L' },
        { id: 121, ch_name: '毫升', en_name: 'Milliliter', tips: '毫升 (Milliliter) - mL' },
        { id: 122, ch_name: '公斤', en_name: 'Kilogram', tips: '公斤 (Kilogram) - kg' },
        { id: 123, ch_name: '公克', en_name: 'Gram', tips: '公克 (Gram) - g' },
        { id: 124, ch_name: '噸', en_name: 'Ton', tips: '噸 (Ton)' },
        { id: 125, ch_name: '盒', en_name: 'Box', tips: '盒 (Box)' },
        { id: 126, ch_name: '公尺', en_name: 'Meter', tips: '公尺 (Meter)' },
        { id: 127, ch_name: '片', en_name: 'Sheet', tips: '片 (Sheet)' },
        { id: 128, ch_name: '張', en_name: 'Piece', tips: '張 (Piece, for larger flat items like paper, fabric)' },
        { id: 151, ch_name: '盒', en_name: 'Box', tips: '盒 (Box)' },
        { id: 152, ch_name: '包', en_name: 'Package', tips: '包 (Package)' },
        { id: 153, ch_name: '瓶', en_name: 'Bottle', tips: '瓶 (Bottle)' },
        { id: 154, ch_name: '支', en_name: 'Vial', tips: '支 (Vial/Ampoule)' },
        { id: 155, ch_name: '針', en_name: 'Syringe', tips: '針 (Syringe)' },
        { id: 156, ch_name: '片', en_name: 'Tablet', tips: '片 (Tablet)' },
        { id: 157, ch_name: '顆', en_name: 'Pill', tips: '顆 (Pill)' },
        { id: 158, ch_name: '袋', en_name: 'Bag', tips: '袋 (Bag)' },
        { id: 159, ch_name: '卷', en_name: 'Roll', tips: '卷 (Roll, for bandages or gauze)' },
        { id: 160, ch_name: '箱', en_name: 'Case', tips: '箱 (Case)' },
        { id: 161, ch_name: '管', en_name: 'Tube', tips: '管 (Tube)' },
        { id: 162, ch_name: '公斤', en_name: 'Kilogram', tips: '公斤 (Kilogram) - kg' },
        { id: 163, ch_name: '毫克', en_name: 'Milligram', tips: '毫克 (Milligram) - mg' },
        { id: 164, ch_name: '公克', en_name: 'Gram', tips: '公克 (Gram) - g' },
        { id: 165, ch_name: '公升', en_name: 'Liter', tips: '公升 (Liter) - L' },
        { id: 166, ch_name: '毫升', en_name: 'Milliliter', tips: '毫升 (Milliliter) - mL' },
        { id: 181, ch_name: '台', en_name: 'Unit', tips: '台 (Unit)' },
        { id: 182, ch_name: '件', en_name: 'Item', tips: '件 (Item)' },
        { id: 183, ch_name: '套', en_name: 'Set', tips: '套 (Set)' },
        { id: 184, ch_name: '張', en_name: 'Bed', tips: '張 (Bed or Sheet)' },
        { id: 185, ch_name: '卷', en_name: 'Roll', tips: '卷 (Roll)' },
        { id: 186, ch_name: '支', en_name: 'Piece', tips: '支 (Piece) - for instruments' },
        { id: 187, ch_name: '公尺', en_name: 'Meter', tips: '公尺 (Meter) - for length-based materials like tubing' },
        { id: 201, ch_name: 'pg', en_name: 'Picogram', tips: '皮克 (Picogram)' },
        { id: 202, ch_name: 'mm', en_name: 'Millimeter', tips: '毫米 (Millimeter)' },
        { id: 203, ch_name: 'mmHg', en_name: 'Millimeters of mercury', tips: '毫米汞柱 (Millimeters of mercury, for blood pressure)' },
        { id: 204, ch_name: '秒', en_name: 'Seconds', tips: '秒 (Seconds) - For clotting time (e.g., PT, aPTT)' },
        { id: 205, ch_name: '滴', en_name: 'drop', tips: '滴(drop)' }

    ];

    getGlobalUnitNameById(id, col) {
        const unitObj = this.global_unit.find(type => type.id === id);
        return unitObj ? unitObj[col] : 'N/A'
    }

    getRecipeUnits() {
        const recipe_unit_ids = [
            41, //克(g) 
            44,//公斤(Kg) 
            51, //公升(L) 
            52,//毫升(mL) 
            56,//匙(Tbsp)  
            73,//塊(block)  
            74,//顆(Piece)  
            94,//隻(bugs) 
            95,//口(mouth) 
            205,//滴(drop)

        ];
        return this.global_unit.filter(unitItem => recipe_unit_ids.includes(unitItem.id));
    }

    controlledLevelList = [
        { id: 1, name: '1級', tips: '' },
        { id: 2, name: '2級', tips: '' },
        { id: 3, name: '3級', tips: '' },
        { id: 4, name: '4級', tips: '' }
    ]

    itemTypes = [
        { id: 1, name: 'A醫用耗材', key: 'consumables' },
        { id: 2, name: 'I儀器、器械', key: 'appliance' },
        { id: 3, name: 'P藥品', key: 'medication' },
        { id: 4, name: 'F食品', key: 'food' },
        { id: 5, name: 'S消耗品', key: 'daily' },
    ]

    getItemType(id) {
        const itemType = this.itemTypes.find(type => type.id === id);
        return itemType ? itemType.name : '?';
    }

    /**
     * 食譜食材種類
     * type_name: 蔬菜 | 水果 | 根莖 | 肉 | 蟲 | 魚 | 蛋 | 採集 | 其他 | 飼料 | 益生菌 | 營養品 | 藥劑 | 奶粉 | 水 | 無
     */
    recipes = [
        { type: 1, icon: 'fa-seedling', type_name: '蔬菜', color: '#216a2d', excludeIntake: false },
        { type: 2, icon: 'fa-apple-whole', type_name: '水果', color: '#f99d28', excludeIntake: false },
        { type: 3, icon: 'fa-carrot', type_name: '根莖', color: '#99640f', excludeIntake: false },
        { type: 4, icon: 'fa-drumstick-bite', type_name: '肉', color: '#d42e2e', excludeIntake: false },
        { type: 5, icon: 'fa-worm', type_name: '蟲', color: '#5a4784', excludeIntake: false },
        { type: 6, icon: 'fa-fish', type_name: '魚', color: '#1098e2', excludeIntake: false },
        { type: 7, icon: 'fa-egg', type_name: '蛋', color: '#cfbf55', excludeIntake: false },
        { type: 8, icon: 'fa-cannabis', type_name: '採集', color: '#3bc1b2', excludeIntake: false },
        { type: 9, icon: 'fa-bone', type_name: '其他', color: '#8e8e8e', excludeIntake: false },
        { type: 10, icon: 'fa-bowl-rice', type_name: '飼料', color: '#472300', excludeIntake: false },
        { type: 11, icon: 'fa-capsules', type_name: '益生菌', color: '#ff6a00', excludeIntake: true },
        { type: 12, icon: 'fa-pills', type_name: '營養品', color: '#173130', excludeIntake: true },
        { type: 13, icon: 'fa-tablets', type_name: '藥劑', color: '#c541cd', excludeIntake: true },
        { type: 14, icon: 'fa-cubes-stacked', type_name: '奶粉', color: '#f88181', excludeIntake: false },
        { type: 15, icon: 'fa-water', type_name: '水', color: '#2e75ac', excludeIntake: true },
        { type: -1, icon: 'fa-hashtag', type_name: '無', color: '#000000', excludeIntake: true }
    ];

    getRecipeStyle(type) {
        if (type === -1) {
            return this.recipes;
        }
        return this.recipes.find(recipe => recipe.type === type) || { icon: 'fa-hashtag', type_name: '無', color: '#000000' };
    }

    recipeTypes = [
        { type: 1, name: '一般食譜' },
        { type: 2, name: '哺乳食譜' }
    ];

    getRecipeTypes(type) {
        if (type === -1) {
            return this.recipeTypes;
        }
        const types = this.recipeTypes.find(types => types.type === type);
        return types ? types.name : '?';
    }

    eatTypes = [
        { type: 1, name: '自行取食' },
        { type: 2, name: '餵食' },
        { type: 3, name: '灌食' },
        { type: 4, name: '塞食' },
    ];

    getEatTypes(type) {
        if (type === -1) {
            return this.eatTypes;
        }
        const eatType = this.eatTypes.find(eatType => eatType.type === type);
        return eatType ? eatType.name : '?';
    }

    care_statue = {
        vitality: [
            { id: 1, name: '正常', icon: 'fa-grin', color: '#28a745' },
            { id: 2, name: '沉鬱', icon: '', color: '#fd7e14' },
            { id: 3, name: '焦躁', icon: '', color: '#ffc107' },
            { id: 4, name: '緊迫', icon: '', color: '#dc3545' },
        ],
        defecation: [
            { id: 1, name: '無', icon: 'fa-meh', color: '#6c757d' },
            { id: 2, name: '正常', icon: 'fa-grin', color: '#28a745' },
            { id: 3, name: '乾便', icon: 'fa-grin', color: '#28a745' },
            { id: 4, name: '軟便', icon: 'fa-frown', color: '#dc3545' },
            { id: 5, name: '下痢', icon: 'fa-frown', color: '#dc3545' },
            { id: 6, name: '糞便含未消化食物', icon: 'fa-frown', color: '#dc3545' },
            { id: 7, name: '黑色便', icon: 'fa-frown', color: '#dc3545' },
            { id: 8, name: '鮮血便', icon: 'fa-frown', color: '#dc3545' },
            { id: 9, name: '綠色便', icon: 'fa-frown', color: '#dc3545' },
            { id: 10, name: '糞便帶黏液', icon: 'fa-frown', color: '#dc3545' },
            { id: 11, name: '白色便', icon: 'fa-frown', color: '#dc3545' }
        ],
        urination: [
            { id: 1, name: '無', icon: 'fa-meh', color: '#6c757d' },
            { id: 2, name: '正常', icon: 'fa-grin', color: '#28a745' },
            { id: 3, name: '血尿', icon: 'fa-frown', color: '#dc3545' },
            { id: 4, name: '分泌物', icon: 'fa-grin', color: '#fd7e14' },
            { id: 5, name: '綠色尿', icon: 'fa-frown', color: '#dc3545' },
            { id: 6, name: '粉紅色尿', icon: 'fa-frown', color: '#dc3545' },
            { id: 7, name: '紅色尿', icon: 'fa-frown', color: '#dc3545' },
            { id: 8, name: '黃色尿', icon: 'fa-frown', color: '#dc3545' },
            { id: 9, name: '橘色尿', icon: 'fa-frown', color: '#dc3545' }
        ],
        cocoon: [
            { id: 1, name: '無', icon: 'fa-meh', color: '#6c757d' },
            { id: 2, name: '有', icon: 'fa-grin', color: '#28a745' },
        ]
    }

    getCareStatueItem(type, id) {
        const status = this.care_statue[type].find(item => item.id === id)
        return status ? status : { id: -1, name: '---', icon: 'fa-meh', color: '#6c757d' }
    }

    dosage_forms = [
        { id: 1, name: '針劑', isPackageMedicine: false, unit: 'mg/ml' },
        { id: 2, name: '粉劑', isPackageMedicine: true, unit: 'mg' },
        { id: 3, name: '膠囊', isPackageMedicine: true, unit: 'mg/cap' },
        { id: 4, name: '藥水(不含糖漿)', isPackageMedicine: true, unit: 'mg/ml' },
        { id: 5, name: '糖漿', isPackageMedicine: true, unit: 'mg/ml' },
        { id: 6, name: '錠', isPackageMedicine: true, unit: 'mg/tab' },
        { id: 7, name: '輸液', isPackageMedicine: true, unit: 'mg/ml' }
    ]

    getDosageFormName(id) {
        if (id === -1) {
            return this.dosage_forms;
        }
        const dosage_form = this.dosage_forms.find(item => item.id == id)
        return dosage_form ? dosage_form.name : '?';
    }

    giveMedicationTimeStep = [
        { id: 1, time: '08:00' },
        { id: 2, time: '11:30' },
        { id: 3, time: '14:30' },
        { id: 4, time: '16:30' }
    ]

    medicine_frequencyList = [
        {
            value: 1, label: 'SID-0800 or 1630(看是早上還晚上)', times: 1, timeStep: [
                this.giveMedicationTimeStep[0],
                this.giveMedicationTimeStep[3]
            ]
        },
        {
            value: 2, label: 'BID-0800、1630', times: 2, timeStep: [
                this.giveMedicationTimeStep[0],
                this.giveMedicationTimeStep[3]
            ]
        },
        {
            value: 3, label: 'QID-0800、1130、1430、1630', times: 4, timeStep: [
                this.giveMedicationTimeStep[0],
                this.giveMedicationTimeStep[1],
                this.giveMedicationTimeStep[2],
                this.giveMedicationTimeStep[3]
            ]
        },
        {
            value: 4, label: 'TID-0800、1130、1630', times: 3, timeStep: [
                this.giveMedicationTimeStep[0],
                this.giveMedicationTimeStep[1],
                this.giveMedicationTimeStep[3]
            ]
        },
        {
            value: 5, label: 'ONCE-基本時段選一：0800 or 1130 or 1430 or 1630', times: 1, timeStep: [
                this.giveMedicationTimeStep[0],
                this.giveMedicationTimeStep[1],
                this.giveMedicationTimeStep[2],
                this.giveMedicationTimeStep[3]
            ]
        },
        {
            value: 6, label: 'QN-1630', times: 1, timeStep: [
                this.giveMedicationTimeStep[3]
            ]
        },
        {
            value: 7, label: 'QW-一週一次', times: 1, timeStep: [
                this.giveMedicationTimeStep[0],
                this.giveMedicationTimeStep[1],
                this.giveMedicationTimeStep[2],
                this.giveMedicationTimeStep[3]
            ]
        }
    ]

    getMedicineFrequencyLabel(value) {
        if (value === -1) {
            return this.medicine_frequencyList;
        }
        const frequency = this.medicine_frequencyList.find(item => item.value == value)
        return frequency ? frequency.label : '?';
    }

    treatmentList = [
        //開藥
        { id: 1, treatment_type: '開藥' },
        //手術麻醉紀錄
        { id: 101, treatment_type: '手術麻醉' },
        { id: 102, treatment_type: '清創麻醉' },
        { id: 103, treatment_type: '診療麻醉' },
        { id: 104, treatment_type: '野放麻醉' },
        { id: 105, treatment_type: '野放麻醉' },
        //檢驗處置 - 內部檢驗
        { id: 201, treatment_type: '血液(血球)檢驗' },
        { id: 202, treatment_type: '血液生化檢驗' },
        { id: 203, treatment_type: '血糖機' },
        { id: 204, treatment_type: '毛細管' },
        { id: 205, treatment_type: '眼壓計' },
        { id: 206, treatment_type: '尿比重計' },
        { id: 207, treatment_type: '抹片檢查' },
        { id: 208, treatment_type: 'X光檢驗' },
        //檢驗處置 - 外部檢驗
        { id: 301, treatment_type: '病毒/抗體' },
        { id: 302, treatment_type: '細菌等微生物' },
        { id: 303, treatment_type: '傷口口水鑑定' },
        { id: 304, treatment_type: '病理解剖' },
        { id: 305, treatment_type: '毒物/重金屬' },
        { id: 306, treatment_type: '內外寄生蟲' },
        { id: 307, treatment_type: '性別/物種鑑定' },
        { id: 308, treatment_type: '荷爾蒙檢測' },
        { id: 309, treatment_type: '其他研究(請備註)' },
        //其他處置
        { id: 401, treatment_type: '其他處置' },
    ]

    //檢驗相關
    exam_type_list = [
        { id: 1, name: '內部檢驗' },
        { id: 2, name: '外部檢驗' },
    ]

    outSide_list = [
        { id: 1, name: "病毒/抗體" },
        { id: 2, name: "細菌等微生物" },
        { id: 3, name: "傷口口水鑑定" },
        { id: 4, name: "病理解剖" },
        { id: 5, name: "毒物/重金屬" },
        { id: 6, name: "內外寄生蟲" },
        { id: 7, name: "性別/物種鑑定" },
        { id: 8, name: "荷爾蒙檢測" },
        { id: 9, name: "其他研究(請備註)" },
    ]

    specimenTypes = [
        { id: 1, name: "大體 Carcass" },
        { id: 2, name: "拭子 Swab" },
        { id: 3, name: "組織/毛髮 Tissue" },
        { id: 4, name: "體液/尿液 Fluid/Urine" },
        { id: 5, name: "血液/血清/血漿 WB/Serum/Plasma" },
        { id: 6, name: "糞便 Feces" },
        { id: 7, name: "寄生蟲 parasites" },
        { id: 8, name: "其他研究檢體" },
    ]

    inSide_list = [
        { id: 1, name: "血液血球檢驗", devices: [ 4 ] },
        { id: 2, name: "血液生化檢驗", devices: [2 , 3 ] },
        { id: 3, name: "血糖機", devices: null },
        { id: 4, name: "毛細管", devices: null },
        { id: 5, name: "眼壓計", devices: null },
        { id: 6, name: "尿比重計", devices: null },
        { id: 7, name: "抹片檢查", devices: null },
        { id: 8, name: "X光檢驗", devices: [8] },
    ]

    device_list = [
        { id: 1, name: "Abacus Vet5" },
        { id: 2, name: "Abasix VetScan V2" },
        { id: 3, name: "IDEXX Catalyst One" },
        { id: 4, name: "IDEXX ProCyte Dx" },
        { id: 8, name: "X-Ray" },
    ]

    examSetting = [
        {
            exam_type: 1,
            exam_device_id: 1,
            item: [
                { key: "WBC", name: "WBC", unit: "10^9/L" },
                { key: "LYM", name: "LYM", unit: "10^9/L" },
                { key: "MON", name: "MON", unit: "10^9/L" },
                { key: "NEU", name: "NEU", unit: "10^9/L" },
                { key: "EOS", name: "EOS", unit: "10^9/L" },
                { key: "BAS", name: "BAS", unit: "10^9/L" },
                { key: "LYM_R", name: "LYM%", unit: "%" },
                { key: "MON_R", name: "MON%", unit: "%" },
                { key: "NEU_R", name: "NEU%", unit: "%" },
                { key: "BAS_R", name: "BAS%", unit: "%" },
                { key: "RBC", name: "RBC", unit: "10^12/L" },
                { key: "HGB", name: "HGB", unit: "g/dl" },
                { key: "HCT", name: "HCT", unit: "%" },
                { key: "MCV", name: "MCV", unit: "fl" },
                { key: "MCH", name: "MCH", unit: "pg" },
                { key: "MCHC", name: "MCHC", unit: "g/dl" },
                { key: "RDWc", name: "RDWc", unit: "%" },
                { key: "RDWs", name: "RDWs", unit: "fl" },
                { key: "PLT", name: "PLT", unit: "10^9/L" },
                { key: "MPV", name: "MPV", unit: "fl" },
                { key: "PCT", name: "PCT", unit: "%" },
                { key: "PDWc", name: "PDWc", unit: "%" },
                { key: "PDWs", name: "PDWs", unit: "fl" }
            ]
        }, {
            exam_type: 1,
            exam_device_id: 4,
            item: [
                { name: "RBC", unit: "M/μL" },
                { name: "HCT", unit: "%" },
                { name: "HGB", unit: "g/dL" },
                { name: "MCV", unit: "fL" },
                { name: "MCH", unit: "pg" },
                { name: "MCHC", unit: "g/dL" },
                { name: "RDW", unit: "%" },
                { name: "%RETIC", unit: "%" },
                { name: "RETIC", unit: "K/μL" },
                { name: "WBC", unit: "K/μL" },
                { name: "%NEU", unit: "%" },
                { name: "%LYM", unit: "%" },
                { name: "%MONO", unit: "%" },
                { name: "%EOS", unit: "%" },
                { name: "%BASO", unit: "%" },
                { name: "NEU", unit: "K/μL" },
                { name: "LYM", unit: "K/μL" },
                { name: "MONO", unit: "K/μL" },
                { name: "EOS", unit: "K/μL" },
                { name: "BASO", unit: "K/μL" },
                { name: "PLT", unit: "K/μL" },
                { name: "MPV", unit: "fL" },
                { name: "PDW", unit: "fL" },
                { name: "PCT", unit: "%" }
            ]
        }, {
            exam_type: 2,
            exam_device_id: 2,
            item: [
                { name: "AST", unit: "U/L" },
                { name: "BA", unit: "umol/L" },
                { name: "TP", unit: "g/dL" },
                { name: "ALB", unit: "g/dL" },
                { name: "GLOB", unit: "g/dL" },
                { name: "CA", unit: "mg/dL" },
                { name: "PHOS", unit: "mg/dL" },
                { name: "GLU", unit: "mg/dL" },
                { name: "CK", unit: "U/L" },
                { name: "UA", unit: "mg/dL" },
                { name: "NA+", unit: "mmol/L" },
                { name: "K+", unit: "mmol/L" },
                { name: "BUN", unit: "mg/dL" },
                { name: "CRE", unit: "mg/dL" },
                { name: "ALT", unit: "U/L" },
                { name: "TBIL", unit: "mg/dL" },
                { name: "tCO2", unit: "mmol/L" },
                { name: "CL-", unit: "mmol/L" },
                { name: "ALP", unit: "U/L" }
            ]
        }, {
            exam_type: 2,
            exam_device_id: 3,
            item: [
                { name: "GLU", unit: "mg/dL" },
                { name: "CREA", unit: "mg/dL" },
                { name: "BUN", unit: "mg/dL" },
                { name: "BUN/CREA", unit: "計算值無單位" },
                { name: "PHOS", unit: "mg/dL" },
                { name: "CA", unit: "mg/dL" },
                { name: "TP", unit: "g/dL" },
                { name: "ALB", unit: "g/dL" },
                { name: "GLOB", unit: "g/dL" },
                { name: "ALB/GOLB", unit: "計算值無單位" },
                { name: "ALB/GLOB", unit: "計算值無單位" },
                { name: "ALT", unit: "U/L" },
                { name: "ALKP", unit: "U/L" },
                { name: "GGT", unit: "U/L" },
                { name: "TBIL", unit: "mg/dL" },
                { name: "CHOL", unit: "mg/dL" },
                { name: "AST", unit: "U/L" },
                { name: "LDH", unit: "U/L" },
                { name: "CK", unit: "U/L" },
                { name: "Na", unit: "mmol/L" },
                { name: "NA+", unit: "mmol/L" },
                { name: "K", unit: "mmol/L" },
                { name: "K+", unit: "mmol/L" },
                { name: "Na/K", unit: "計算值無單位" },
                { name: "Cl", unit: "mmol/L" },
                { name: "CL-", unit: "mmol/L" },
                { name: "LAC", unit: "mmol/L" },
                { name: "TRIG", unit: "mg/dL" },
                { name: "Osm Calc", unit: "mmol/kg" },
                { name: "NH3", unit: "" },
                { name: "URIC(UA)", unit: "" },
                { name: "Mg", unit: "" },
                { name: "PT", unit: "" },
                { name: "aPTT", unit: "" }
            ]
        }, {
            exam_type: 3,
            exam_device_id: null,
            item: [
                { name: "Glucose", unit: "" }
            ]
        }, {
            exam_type: 4,
            exam_device_id: null,
            item: [
                { name: "PCV", unit: "%" }
            ]
        }, {
            exam_type: 5,
            exam_device_id: null,
            item: [
                { name: "眼壓", unit: "mmHg" }
            ]
        }, {
            exam_type: 6,
            exam_device_id: null,
            item: [
                { name: "尿比重", unit: "" }
            ]
        }, {
            exam_type: 7,
            exam_device_id: null,
            item: null
        }, {
            exam_type: 8,
            exam_device_id: 8,
            item: null
        }
    ]

    /**
     * 正規化單位字串（去除符號、特殊字元、空白並轉為小寫）
     * @param {string|null|undefined} unit 原始單位字串
     * @returns {string} 正規化後的單位字串
     */
    normalizeUnit(unit) {
        if (unit === null || unit === undefined) return '';
        const str = String(unit).trim().toLowerCase();
        if (str === '計算值無單位' || str === '無單位' || str === '無' || str === 'none') {
            return '';
        }
        return str.replace(/[^a-z0-9\u03bc]/gi, '');
    }

    /**
     * 比對兩單位是否相符（忽略符號與大小寫）
     * @param {string|null|undefined} unitA 單位 A
     * @param {string|null|undefined} unitB 單位 B
     * @returns {boolean} 是否相符
     */
    compareUnit(unitA, unitB) {
        return this.normalizeUnit(unitA) === this.normalizeUnit(unitB);
    }

    /**
     * 正規化檢驗項目名稱（去除符號、空白並轉為小寫）
     * @param {string|null|undefined} name 原始項目名稱
     * @returns {string} 正規化後的項目名稱
     */
    normalizeItemName(name) {
        if (name === null || name === undefined) return '';
        return String(name).trim().toLowerCase().replace(/[^a-z0-9]/gi, '');
    }

    /**
     * 比對兩項目名稱是否相符（忽略符號與大小寫）
     * @param {string|null|undefined} nameA 項目名稱 A
     * @param {string|null|undefined} nameB 項目名稱 B
     * @returns {boolean} 是否相符
     */
    compareItemName(nameA, nameB) {
        if (!nameA || !nameB) return false;
        if (nameA === nameB) return true;
        return this.normalizeItemName(nameA) === this.normalizeItemName(nameB);
    }

    /**
     * 獨立檢驗單位對照表（不綁定特定檢驗類型與設備）
     */
    testUnits = [
        // --- 血液血球檢驗 (CBC) ---
        { name: "WBC", unit: "K/μL" },
        { name: "RBC", unit: "M/μL" },
        { name: "HGB", unit: "g/dL" },
        { name: "HCT", unit: "%" },
        { name: "MCV", unit: "fL" },
        { name: "MCH", unit: "pg" },
        { name: "MCHC", unit: "g/dL" },
        { name: "PLT", unit: "K/μL" },
        { name: "RDW", unit: "%" },
        { name: "RDWc", unit: "%" },
        { name: "RDWs", unit: "fL" },
        { name: "%RETIC", unit: "%" },
        { name: "RETIC", unit: "K/μL" },
        { name: "NEU", unit: "K/μL" },
        { name: "%NEU", unit: "%" },
        { name: "NEU%", unit: "%" },
        { name: "NEU_R", unit: "%" },
        { name: "LYM", unit: "K/μL" },
        { name: "%LYM", unit: "%" },
        { name: "LYM%", unit: "%" },
        { name: "LYM_R", unit: "%" },
        { name: "MONO", unit: "K/μL" },
        { name: "MON", unit: "K/μL" },
        { name: "%MONO", unit: "%" },
        { name: "MON%", unit: "%" },
        { name: "MON_R", unit: "%" },
        { name: "EOS", unit: "K/μL" },
        { name: "%EOS", unit: "%" },
        { name: "EOS%", unit: "%" },
        { name: "BASO", unit: "K/μL" },
        { name: "BAS", unit: "K/μL" },
        { name: "%BASO", unit: "%" },
        { name: "BAS%", unit: "%" },
        { name: "BAS_R", unit: "%" },
        { name: "MPV", unit: "fL" },
        { name: "PCT", unit: "%" },
        { name: "PDW", unit: "fL" },
        { name: "PDWc", unit: "%" },
        { name: "PDWs", unit: "fL" },

        // --- 血液生化檢驗 (Biochemistry) ---
        { name: "GLU", unit: "mg/dL" },
        { name: "Glucose", unit: "mg/dL" },
        { name: "CREA", unit: "mg/dL" },
        { name: "CRE", unit: "mg/dL" },
        { name: "BUN", unit: "mg/dL" },
        { name: "BUN/CREA", unit: "" },
        { name: "PHOS", unit: "mg/dL" },
        { name: "CA", unit: "mg/dL" },
        { name: "TP", unit: "g/dL" },
        { name: "ALB", unit: "g/dL" },
        { name: "GLOB", unit: "g/dL" },
        { name: "ALB/GLOB", unit: "" },
        { name: "ALB/GOLB", unit: "" },
        { name: "ALT", unit: "U/L" },
        { name: "ALKP", unit: "U/L" },
        { name: "ALP", unit: "U/L" },
        { name: "AST", unit: "U/L" },
        { name: "GGT", unit: "U/L" },
        { name: "TBIL", unit: "mg/dL" },
        { name: "CHOL", unit: "mg/dL" },
        { name: "LDH", unit: "U/L" },
        { name: "CK", unit: "U/L" },
        { name: "Na", unit: "mmol/L" },
        { name: "NA+", unit: "mmol/L" },
        { name: "K", unit: "mmol/L" },
        { name: "K+", unit: "mmol/L" },
        { name: "Cl", unit: "mmol/L" },
        { name: "CL-", unit: "mmol/L" },
        { name: "Na/K", unit: "" },
        { name: "LAC", unit: "mmol/L" },
        { name: "TRIG", unit: "mg/dL" },
        { name: "Osm Calc", unit: "mmol/kg" },
        { name: "BA", unit: "umol/L" },
        { name: "UA", unit: "mg/dL" },
        { name: "URIC(UA)", unit: "mg/dL" },
        { name: "tCO2", unit: "mmol/L" },
        { name: "NH3", unit: "" },
        { name: "Mg", unit: "" },
        { name: "PT", unit: "" },
        { name: "aPTT", unit: "" },

        // --- 其他檢驗 ---
        { name: "PCV", unit: "%" },
        { name: "眼壓", unit: "mmHg" },
        { name: "尿比重", unit: "" }
    ]

    /**
     * 取得檢驗項目對應的單位
     * @param {string|null|undefined} key 檢驗項目名稱
     * @returns {string} 單位字串，若找不到或無單位則回傳空字串
     */
    getTestUnit(key) {
        if (!key) return '';
        try {
            // 1. 精確比對
            let matched = this.testUnits.find(item => item.name === key);
            // 2. 忽略符號與大小寫容錯比對
            if (!matched) {
                matched = this.testUnits.find(item => this.compareItemName(item.name, key));
            }
            if (matched && matched.unit) {
                const normalized = matched.unit.trim();
                if (
                    normalized === '計算值無單位' ||
                    normalized === '無單位' ||
                    normalized === '無' ||
                    normalized === '?'
                ) {
                    return '';
                }
                return normalized;
            }
            return '';
        } catch (error) {
            console.error('[parameters] getTestUnit 發生錯誤:', error);
            return '';
        }
    }


    getSpecimenTypes(type) {
        if (type === -1) {
            return this.specimenTypes;
        }
        const specimenType = this.specimenTypes.find(specimenType => specimenType.id === type);
        return specimenType ? specimenType.name : '?';
    }
    anesthesiaTypeList = [
        { id: 1, name: '手術麻醉' },
        { id: 2, name: '清創麻醉' },
        { id: 3, name: '診療麻醉' },
        { id: 4, name: '野放麻醉' },

    ]

    tubeSizeList = [
        { id: 0, name: '無插管' },
        { id: 1, name: 'Cole-Type I.D. 1.0mm' },
        { id: 2, name: 'Cole-Type I.D. 1.5mm' },
        { id: 3, name: 'Cole-Type I.D. 2.0mm' },
        { id: 4, name: 'Cole-Type I.D. 2.5mm' },
        { id: 5, name: 'Cole-Type I.D. 3.0mm' },
        { id: 6, name: 'Cole-Type I.D. 3.5mm' },
        { id: 7, name: 'Cole-Type I.D. 4.0mm' },
        { id: 8, name: 'Cole-Type I.D. 5.0mm' },
        { id: 9, name: 'Cole-Type I.D. 6.0mm' },
        { id: 10, name: 'uncuffed I.D 2.0 mm' },
        { id: 11, name: 'uncuffed I.D 2.5 mm' },
        { id: 12, name: 'cuffed I.D 2.0 mm' },
        { id: 13, name: 'cuffed I.D 2.5 mm' },
        { id: 14, name: 'cuffed I.D 3.0mm' },
        { id: 15, name: 'cuffed I.D 3.5mm' },
        { id: 16, name: 'cuffed I.D 4.0mm' },
        { id: 17, name: 'cuffed I.D 4.5mm' },
        { id: 18, name: 'cuffed I.D 5.0mm' },
        { id: 19, name: 'cuffed I.D 5.5mm' },
        { id: 20, name: 'cuffed I.D 6.0mm' },
        { id: 21, name: 'cuffed I.D 6.5mm' },
        { id: 22, name: 'cuffed I.D 7.0mm' },
        { id: 23, name: 'cuffed I.D 7.5mm' },
        { id: 24, name: 'cuffed I.D 8.0mm' },
        { id: 25, name: 'cuffed I.D 8.5mm' },
        { id: 26, name: 'cuffed I.D 9.0mm' },
        { id: 27, name: 'cuffed I.D 10.0mm' },
        { id: 28, name: 'cuffed I.D 11.0mm' },
        { id: 29, name: 'cuffed I.D 12.0mm' },
        { id: 30, name: 'cuffed I.D 13.0mm' }
    ]

    smearTypes = [
        { id: 1, name: '血液抹片' },
        { id: 2, name: '細胞學抹片' },
        { id: 3, name: '糞便抹片' },
        { id: 4, name: '其他' },
    ]

    getSmearTypesName(id) {
        const item = this.smearTypes.find(item => item.id === id)
        return item ? item.name : 'N/A'
    }

    coloringList = [
        { id: 1, name: '染色方式A' },
        { id: 2, name: '染色方式B' },
        { id: 3, name: '染色方式C' }
    ]

    getColoringName(id) {
        const item = this.coloringList.find(item => item.id === id)
        return item ? item.name : 'N/A'
    }

    priorityType = [
        { id: 1, name: "低" },
        { id: 2, name: "一般" },
        { id: 3, name: "緊急" },
        { id: 4, name: "重要" },
    ]

    getPriorityType(type) {
        if (type === -1) {
            return this.priorityType;
        }
        const priorityType = this.priorityType.find(priority => priority.id === type);
        return priorityType ? priorityType.name : '?';
    }

    taskType = [
        { id: 1, name: "單次" },
        { id: 2, name: "常規" },
    ]

    getTaskType(type) {
        if (type === -1) {
            return this.taskType;
        }
        const getTaskType = this.taskType.find(task => task.id === type);
        return getTaskType ? getTaskType.name : '?';
    }

    scheduleTypes = [
        {
            id: 1,
            scheduleTypeCode: "W0001",
            scheduleTypeName: "上班",
            isWork: true,
            scheduleTypeDescription: "選擇此狀態班次代碼、上班時間、下班時間為必填. 若未填寫休息時間，將以原班次休息時間為準。"
        },
        {
            id: 2,
            scheduleTypeCode: "H0001",
            scheduleTypeName: "休假日",
            isWork: false,
            scheduleTypeDescription: "如不區分休息日、例假日，可選擇此狀態"
        },
        {
            id: 3,
            scheduleTypeCode: "H0002",
            scheduleTypeName: "休息日",
            isWork: false,
            scheduleTypeDescription: "選擇此狀態設定休息日"
        },
        {
            id: 4,
            scheduleTypeCode: "H0003",
            scheduleTypeName: "例假日",
            isWork: false,
            scheduleTypeDescription: "選擇此狀態設定例假日"
        },
        {
            id: 5,
            scheduleTypeCode: "M0001",
            scheduleTypeName: "月休",
            isWork: false,
            scheduleTypeDescription: "選擇此狀態將扣除月休日數"
        },
        {
            id: 6,
            scheduleTypeCode: "M0002",
            scheduleTypeName: "月休-國定假日",
            isWork: false,
            scheduleTypeDescription: "選擇此狀態將扣除月休-國定假日數"
        },
        {
            id: 7,
            scheduleTypeCode: "M0003",
            scheduleTypeName: "月休-休息日",
            isWork: false,
            scheduleTypeDescription: "選擇此狀態將扣除月休-休息日數"
        },
        {
            id: 8,
            scheduleTypeCode: "M0004",
            scheduleTypeName: "月休-例假日",
            isWork: false,
            scheduleTypeDescription: "選擇此狀態將扣除月休-例假日數"
        }
    ];


    scheduleClassList = [
        {
            id: 1,
            scheduleClassCode: "A001",
            scheduleClassName: "常日班",
            start_work_time: '09:00',
            off_work_time: '18:00',
            time: 8
        },
        // {
        //     id: 2,
        //     scheduleClassCode: "A002",
        //     scheduleClassName: "早班",
        //     start_work_time:'08:00',
        //     off_work_time:'17:00',
        //     time:8
        // },
        // {
        //     id: 3,
        //     scheduleClassCode: "A006",
        //     scheduleClassName: "晚班",
        //     start_work_time:'08:00',
        //     off_work_time:'17:00',
        //     time:8
        // },
        // {
        //     id: 4,
        //     scheduleClassCode: "A008",
        //     scheduleClassName: "台東處班",
        //     start_work_time:'08:00',
        //     off_work_time:'17:00',
        //     time:8
        // },
        // {
        //     id: 5,
        //     scheduleClassCode: "A009",
        //     scheduleClassName: "清潔班",
        //     start_work_time:'08:00',
        //     off_work_time:'17:00',
        //     time:8
        // },
        {
            id: 6,
            scheduleClassCode: "A010",
            scheduleClassName: "超早班",
            start_work_time: '08:00',
            off_work_time: '17:00',
            time: 8
        },
        // {
        //     id: 7,
        //     scheduleClassCode: "A011",
        //     scheduleClassName: "清潔半日班",
        //     start_work_time:'08:00',
        //     off_work_time:'17:00',
        //     time:8
        // },
        {
            id: 8,
            scheduleClassCode: "N001",
            scheduleClassName: "空班",
            start_work_time: '09:00',
            off_work_time: '18:00',
            time: 8
        }
    ];


    //以下為測試時使用

    //取得受理單狀態
    getIntakeStatus(id) {

        let status = []
        status[0] = '受理中'
        status[1] = '入院'
        status[2] = '手術中'
        status[3] = 'ICU'
        status[4] = '禁食中'
        status[5] = '野訓中'
        status[6] = '等待野放'
        status[91] = '結案-追蹤中'
        status[92] = '結案-已野放'
        status[93] = '結案-死亡'
        status[94] = '結案-轉診'
        status[95] = '結案-轉收容'


        return status[id]
    }

    getAccountStatus(id) {

        let status = []
        status[0] = ''
        status[1] = '停用'

        return status[id]
    }

    getTakerRecodeStatus(key, status_id = null) {
        const statusList = {
            spirit: [
                { status_id: 0, status_name: '正常', icon: 'fa-meh', color: "#29a745" },
                { status_id: 0, status_name: '正常', icon: 'fa-meh', color: "#dc3545" },
            ]
        }

        if (status_id !== null) {
            return statusList[key].find(status => status.status_id === status_id) || statusList[key];
        }

        return statusList[key];
    }

    initExamineType = [
        {
            "id": 1,
            "name": "紅色 - 緊急"
        },
        {
            "id": 2,
            "name": "黃色 - 優先"
        },
        {
            "id": 3,
            "name": "綠色 - 非緊急"
        },
        {
            "id": 4,
            "name": "黑色 - 不可逆"
        },
        {
            "id": 5,
            "name": "藍色 - 輕傷"
        }
    ]


    units = [
        { type: 0, unit: 'g' },
        { type: 1, unit: 'ml' },
        { type: 2, unit: 'cc' },
        { type: 3, unit: '顆' },
        { type: 4, unit: '包' },
        { type: 5, unit: '支' },
        { type: 6, unit: '盒' },
        { type: 7, unit: '袋' },
        { type: 8, unit: 'kg' },
        { type: 9, unit: '個' },
        { type: 10, unit: '瓶' },
        { type: 11, unit: '罐' },
    ]

    dosageUnit = [
        { type: 0, unit: 'g' },
        { type: 1, unit: 'ml' },
        { type: 2, unit: 'cc' },
    ]
    getDosageUnit(type) {
        if (type === -1) {
            return this.dosageUnit;
        }
        const unit = this.dosageUnit.find(unit => unit.type === type);
        return unit ? unit.unit : '?';
    }

    recipeUnits = [
        { type: 0, unit: 'g' },
        { type: 1, unit: 'ml' },
        { type: 2, unit: 'cc' },
        { type: 3, unit: '顆' },
        { type: 4, unit: '隻' },
        { type: 5, unit: '口' }
    ];

    getRecipeUnit(type) {
        if (type === -1) {
            return this.recipeUnits;
        }
        const unit = this.recipeUnits.find(unit => unit.type === type);
        return unit ? unit.unit : '?';
    }



    processTypes = [
        { type: 0, name: '泥' },
        { type: 1, name: '塊1*1' },
        { type: 2, name: '塊2*2' },
        { type: 3, name: '塊3*3' },
        { type: 4, name: '塊5*5' },
        { type: 5, name: '塊10*10' },
        { type: 6, name: '片1*1' },
        { type: 7, name: '片2*2' },
        { type: 8, name: '條2*2*10' },
        { type: 9, name: '條3*3*10' },
        { type: 10, name: '條5*5*15' },
    ]

    getProcessTypes(type) {
        if (type === -1) {
            return this.processTypes;
        }
        const processType = this.processTypes.find(processType => processType.type === type);
        return processType ? processType.name : '?';
    }

    eatTimes = Array.from({ length: 48 }, (_, index) => {
        const hour = String(Math.floor(index / 2)).padStart(2, '0');
        const minute = index % 2 === 0 ? '00' : '30';
        return `${hour}:${minute}`;
    });



    inspectionUnits = [
        { id: 0, name: "野灣院內" },
        { id: 1, name: "中興微生物" },
        { id: 2, name: "周洵老師" },
        { id: 3, name: "屏科診中" },
        { id: 4, name: "臺大動物法醫" },
        { id: 5, name: "臺大公衛所" },
        { id: 6, name: "獸醫所" },
        { id: 7, name: "屏科鳥店" },
        { id: 8, name: "大安聯合" },
        { id: 9, name: "合作_中興黴漿菌" },
        { id: 10, name: "盤古林" },
        { id: 11, name: "賴奕德博士" },
        { id: 12, name: "(停送)臺大昆蟲系" },
        { id: 13, name: "嘉大獸醫郭鴻志老師" },
        { id: 14, name: "芮弗士" },
    ]

    getInspectionUnits(type) {
        if (type === -1) {
            return this.inspectionUnits;
        }
        const inspectionUnit = this.inspectionUnits.find(inspectionUnit => inspectionUnit.id === type);
        return inspectionUnit ? inspectionUnit.name : '?';
    }



    locations = [
        { id: 0, name: '診療室', type: 0 },
        { id: 1, name: '住院室', type: 0 },
        { id: 2, name: 'ICU室', type: 0 },
        { id: 3, name: '二辦', type: 1 },
        { id: 4, name: '哺乳室', type: 0 },
        { id: 5, name: '廚房', type: 1 },
    ]

    getLocations(id) {
        if (id === -1) {
            return this.locations;
        }
        const locations = this.locations.find(task => task.id === id);
        return locations ? locations.name : '?';
    }



    getItemTypeObj(id) {
        if (id === -1) {
            return this.itemTypes;
        }
        const itemType = this.itemTypes.find(type => type.id === id);
        return itemType ? itemType : '?';
    }




    purchaseStatus = [
        { id: 0, name: '採購中' },
        { id: 1, name: '已入庫' },
    ]

    getPurchaseStatus(id) {
        if (id === -1) {
            return this.purchaseStatus;
        }
        const status = this.purchaseStatus.find(status => status.id === id);
        return status ? status.name : '?';
    }



    routeList = [
        { value: 0, label: '口服' },
        { value: 1, label: '針劑' },
        { value: 2, label: '外用' },
    ]

    getRouteListLabel(value) {
        if (value === -1) {
            return this.routeList;
        }
        const route = this.routeList.find(item => item.value == value)
        return route ? route.label : '?';
    }







}
export default Parameters